// extracted by mini-css-extract-plugin
module.exports =  {"project":"FA3X2aQa7VBQx5wnv3L6","button":"NWtTwdMMGoLcwHKAzS2N","courses":"q3bkoLUSDDHEChz6X9Qj","iaPanel":"Agsyg2B5HHRtcMUtF5T1"};